module.exports = __webpack_public_path__ + "static/media/Group 287.0e066cb7.png";